import {ernstPurchaseSnapshot} from './photo/photo-purchase-snapshot';
import type {ConfiguratorSnapshot} from './design/configurator/integration';

/** Explicit nulls clear old Basic data through the plan API's shallow JSON merge. */
export function customPurchaseLayout(direction:string|undefined, inspirationId:string|undefined, snapshot:ConfiguratorSnapshot) {
  if(direction==='custom') {
    const configured={...ernstPurchaseSnapshot(),quoteSettings:snapshot.quoteSettings};
    return {bunkModelId:'ernst',bunkModelLabel:'Ernst',configuratorSnapshot:configured,rooms:[{id:'consultative-room',name:'Your Bliss room',configuratorSnapshot:configured}]};
  }
  if(direction==='one_of_a_kind' && inspirationId==='storybook') return {bunkModelId:'castle',bunkModelLabel:'Castle',configuratorSnapshot:null,rooms:null};
  return null;
}
